

import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import googlePlay from '../../ImageAssets/googleplay.png';
import appStore from '../../ImageAssets/appstore.png';
import Background from '../../ImageAssets/blueskyBackground.png';
import Network from '../../Utils/network.js';
import ValidateForm from '../../Utils/formValidation';
import { setForgetPasswordDetails, setLoginPage } from '../../General/Actions';
import Swal from 'sweetalert2';
import SignUpComponent from './SignUpComponent';
import { FaArrowLeft } from 'react-icons/fa';
import LoadingAnimation from '../../Utils/loadingAnimation.js';

class changeUsernameComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }


    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }



    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }

    arrowIconClicked() {
        window.location.reload();
    }


    changeUsernameSubmit() {
        if (ValidateForm.inputFieldMandatoryCheck("forgetPasswordChangePasswordContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("forgetPasswordChangePasswordContainer", this.props.locales, false)) {
                if (this.state.newUsername === this.state.confirmUsername) {
                    if (this.props.forgetPasswordDetails.retreivedUsername === this.state.newUsername) {
                        Swal.fire(this.props.locales.enterNewusernameInSwal, "", "");
                    } else {
                        this.setState({isLoading: true})
                        Network.executeAxios("duplicateUsernameCheck", "POST", { "username": this.state.newUsername }, (duplicateUsernameCheckResponse) => {
                            if (duplicateUsernameCheckResponse.STATUS === "USER_ALREADY_EXIST") {
                                this.setState({ isLoading: false })
                                Swal.fire(this.props.locales.duplicateUsernameInSwal, "", "");
                            } else {
                                setTimeout(() => {
                                    var dataToSend = {
                                        username: this.state.newUsername,
                                        profileId: this.props.userRegisterDetails.customerId
                                    }
                                    this.setState({ isLoading: true })
                                    Network.executeAxios("forgetUsernameSetUsername", "POST", dataToSend, (setUsernameResponse) => {
                                        if (setUsernameResponse.STATUS === "SUCCESS") {
                                            Swal.fire(this.props.locales.usernameSuccessfullyInSwal, "", "");
                                            window.location.reload();
                                        } else if (setUsernameResponse.STATUS === "FAILED") {
                                            this.setState({ isLoading: false })
                                            Swal.fire(this.props.locales.usernameUpdationFailedInSwal, "", "");
                                        }
                                    });
                                }, 100);
                            }
                        })
                    }
                } else {
                    Swal.fire(this.props.locales.usernameDoesntMatchSwalTitleMsg, "", "");
                }

            }
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetPasswordSetPasswordOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetPasswordSetPasswordOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.changeUsernamePartComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    changeUsernamePartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                <div className="d-md-none col-md-12 p-0">
                    <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                        <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.arrowIconClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                    </div>
                </div>
                <div className="col-md-12 row py-5 m-0 my-5 d-none d-sm-block">


                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 pl-sm-5 pl-2 pt-4" id="forgetPasswordChangePasswordContainer">
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.enterUsernameInChangeUsername}</div>
                        <div className="col-md-12 pt-2 pb-3" style={{ fontSize: 16, color: '#404042' }}>{this.props.locales.enterUsernameNotUsedBeforeText}</div>
                        <div className="form-group col-md-12 pb-3">
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.enterUsernameInChangeUsername}</label>
                            <Input type="text" name="newUsername" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typeName pt-4 pb-3"
                                placeholder={this.props.locales.enterUsernameInChangeUsername} onChange={(event) => this.inputValueChange("newUsername", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.newUsername, this.props.locales.enterUsernameInChangeUsername)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-12" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.confirmUsernameText}</label>
                            <Input type="text" name="confirmUsername" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typeName pt-4 pb-3"
                                placeholder={this.props.locales.confirmUsernameText} onChange={(event) => this.inputValueChange("confirmUsername", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.confirmUsername, this.props.locales.confirmUsernameText)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>

                        <div className="col-md-12 pt-4">
                            <Button className="loginPageLoginButton" onClick={() => { this.changeUsernameSubmit() }}>
                                {this.props.locales.changeUsernameConfirmButtonText}
                            </Button>
                        </div>

                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    loginPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 p-0 row m-0 pt-5 pb-5" style={{ backgroundColor: '#000000', height: 'inherit', flex: 1 }}>
                <div className="col-md-1"></div>
                <div className="col-md-9 pl-5 pr-4 row pt-5 mt-5" style={{ flex: 1, alignItems: "center", justifyContent: "center", height: 'inherit' }}>
                    <div className="col-md-12 row" >
                        <div className="mb-1 col-md-12" style={{ fontSize: 35, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.changePasswordNwCanDownloadTxt}</div>
                        <div className=" col-md-12 pt-5 d-flex p-0">
                            <div className="col-md-6 p-0 text-center"><img alt="" src={googlePlay} width="180" /></div>
                            <div className="col-md-6 p-0 text-center"><img alt="" src={appStore} width="180" /></div>
                        </div>
                    </div>
                </div>
                <div className="col-md-2"></div>
            </div>
        )
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        forgetPasswordDetails: state.forgetPasswordDetails,
        userRegisterDetails: state.userRegisterDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        }
    }
}

const changeUsernameComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(changeUsernameComponent)


export default changeUsernameComponentContainer;